module.exports = __webpack_public_path__ + "img/logo.a65d5592.png";